import React from 'react';
import moment from 'moment';
import { Col, Row } from 'reactstrap';
import { DataGrid } from '@mui/x-data-grid';

const TrainingList = (props) => {

    const handleSelect = (selectedItem) => {
        props.onSelect && props.onSelect(selectedItem.id);
    }

    const columns = [
        {
            field: 'projectName',
            headerName: 'Project',
            flex: 3,
        },
        {
            field: 'trainingType',
            headerName: 'Training',
            flex: 3,
        },
        {
            field: 'city',
            headerName: 'City',
            flex: 3,
        },
        {
            field: 'state',
            headerName: 'State',
            flex: 3,
        },
        {
            field: 'trainingLocation',
            headerName: 'Location Type',
            flex: 3,
        },
        {
            field: 'startDate',
            headerName: 'Start Date',
            valueFormatter: (params) => moment(params.value).format('MMM Do YYYY'),
            flex: 3,
        },
        {
            field: 'endDate',
            headerName: 'End Date',
            valueFormatter: (params) => moment(params.value).format('MMM Do YYYY'),
            flex: 3,
        },
    ];

    return (
        <React.Fragment>
            <Row className='mb-1'>
                <Col>
                    <h3>Trainings</h3>
                </Col>
            </Row>
            <div className='ag-theme-balham' style={{ width: 'auto' }}>
                <DataGrid
                    rows={props.data.map(x => { return { id: x.trainingId, ...x } })}
                    onRowDoubleClick={(e) => handleSelect(e)}
                    autoHeight={true}
                    rowHeight={35}
                    initialState={{
                        pagination: { paginationModel: { pageSize: 25 } },
                    }}
                    columns={columns}
                    sx={{
                        backgroundColor: 'white'
                    }}
                    getRowClassName={(params) => 'grid-row'}
                />
            </div>
        </React.Fragment>
    );
};

export default TrainingList;